/* Nische wishlist page.
   Reads the saved handles from localStorage and pulls each product's card
   markup from /products/<handle>?view=nische-card, so the cards here are the
   exact same snippet used everywhere else. Rerenders live: removing a heart
   drops the card immediately, with no reload. */
(function () {
  'use strict';

  var root = document.querySelector('[data-nc-wishlist-page]');
  if (!root) return;

  var grid = root.querySelector('[data-nc-wishlist-grid]');
  var empty = root.querySelector('[data-nc-wishlist-empty]');
  var loading = root.querySelector('[data-nc-wishlist-loading]');
  var countEl = root.querySelector('[data-nc-wishlist-heading-count]');

  var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cache = {};
  var rendered = [];

  function wishlist() {
    return (window.NischeWishlist && window.NischeWishlist.read()) || [];
  }

  /* The card view (templates/product.nische-card.liquid) cannot see this
     section's settings, so the "Image ratio" choice is applied here, on the
     same --nc-ratio custom property the shared card snippet sets inline.
     "adapt" reads the featured image's own width/height attributes - the
     same aspect ratio Liquid would have used. */
  function applyRatio(li) {
    var mode = root.getAttribute('data-nc-wishlist-ratio') || 'portrait';
    var card = li.querySelector('.nc-card');
    if (!card) return;
    var ratio = 1;
    if (mode === 'portrait') {
      ratio = 0.8;
    } else if (mode === 'adapt') {
      var img = li.querySelector('.nc-card__img--one');
      var w = img && parseFloat(img.getAttribute('width'));
      var h = img && parseFloat(img.getAttribute('height'));
      if (w > 0 && h > 0) ratio = w / h;
    }
    card.style.setProperty('--nc-ratio', ratio);
  }

  function setState(count) {
    if (loading) loading.hidden = true;
    if (empty) empty.hidden = count > 0;
    if (grid) grid.hidden = count === 0;
    if (countEl) countEl.textContent = count === 1 ? '1 item' : count + ' items';
  }

  function fetchCard(handle) {
    if (cache[handle] !== undefined) return Promise.resolve(cache[handle]);
    return fetch(base + 'products/' + encodeURIComponent(handle) + '?view=nische-card')
      .then(function (res) {
        if (!res.ok) throw new Error('not found');
        return res.text();
      })
      .then(function (html) {
        cache[handle] = html;
        return html;
      })
      .catch(function () {
        /* Product unpublished or deleted since it was saved - forget it. */
        cache[handle] = null;
        if (window.NischeWishlist) window.NischeWishlist.remove(handle);
        return null;
      });
  }

  function render() {
    var handles = wishlist();

    if (!handles.length) {
      grid.innerHTML = '';
      rendered = [];
      setState(0);
      return;
    }

    Promise.all(handles.map(fetchCard)).then(function (cards) {
      var frag = document.createDocumentFragment();
      var live = [];

      cards.forEach(function (html, i) {
        if (!html) return;
        var li = document.createElement('li');
        li.className = 'grid__item nc-wishlist__item';
        li.setAttribute('data-nc-wishlist-item', handles[i]);
        li.innerHTML = html;
        applyRatio(li);
        frag.appendChild(li);
        live.push(handles[i]);
      });

      grid.innerHTML = '';
      grid.appendChild(frag);
      rendered = live;
      setState(live.length);

      if (window.NischeWishlist) window.NischeWishlist.hydrate(grid);
    });
  }

  /* A heart toggled anywhere. If it was un-saved and its card is on this page,
     fade that card out rather than rebuilding the whole grid. */
  document.addEventListener('nische:wishlist:change', function (evt) {
    var detail = evt.detail || {};

    if (detail.added === false) {
      var item = grid.querySelector('[data-nc-wishlist-item="' + CSS.escape(detail.handle) + '"]');
      if (item) {
        item.classList.add('nc-wishlist__item--out');
        var idx = rendered.indexOf(detail.handle);
        if (idx !== -1) rendered.splice(idx, 1);
        setTimeout(function () {
          item.remove();
          setState(rendered.length);
        }, 220);
        return;
      }
    }

    render();
  });

  render();
})();
